import {
  Typography,
  Box,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  SvgIcon,
} from "@mui/material";
import {
  Logout as LogoutIcon,
  ManageAccountsOutlined as ManageAccountsOutlinedIcon,
} from "@mui/icons-material";
import { useAuth } from "../../auth/context";
import AvatarUser from "./AvatarUser";
import { useIsInQuickLink, useNavigate } from "../../utils/hooks";
import _ from "lodash";

export default function MenuIListUser() {
  const { user, signout } = useAuth();
  const navigate = useNavigate();
  const isInQuickLink = useIsInQuickLink();

  const actions = [
    {
      name: "Ajustes de cuenta",
      onClick: () => navigate("/settings"),
      icon: <ManageAccountsOutlinedIcon />,
    },
    { name: "Cerrar sesión", onClick: signout, icon: <LogoutIcon />, disabled: isInQuickLink },
  ];

  return (
    <Grid item sx={12}>
      <Box sx={{ p: 2 }}>
        <Typography
          sx={{ color: "#132643" }}
        >{`${user.name} ${user.surname}`}</Typography>
        <Typography sx={{ fontSize: "14px", color: "#828B97" }}>
          {user.email}
        </Typography>
      </Box>
      <Divider />
      <Typography fontWeight="fontWeightBold" sx={{ pl: 2, pt: 1 }}>
        Perfiles
      </Typography>

      <Box sx={{ p: 2, display: "flex", alignItems: "center" }}>
        <AvatarUser />
        <Typography fontWeight="fontWeightBold" sx={{ pl: 2 }}>
          Particular
        </Typography>
      </Box>

      <Divider />
      <MenuList>
        {_(actions).reject("disabled").map(({ name, onClick, icon }) => (
          <MenuItem
            sx={{ "&:hover": { bgcolor: "#D3E9FB" } }}
            onClick={onClick}
          >
            <ListItemIcon>
              <SvgIcon sx={{ color: "grey.main", fontSize: 20 }}>
                {icon}
              </SvgIcon>
            </ListItemIcon>

            <ListItemText>
              <Typography variant="body1" color="grey.main" sx={{ ml: 1 }}>
                {name}
              </Typography>
            </ListItemText>
          </MenuItem>
        )).value()}
      </MenuList>
    </Grid>
  );
}
